export interface Interest {
    Id: number;
    Name: string;
}

export class InterestModel {
    name: string;
}

export class EditInterest extends InterestModel {
    public id: number;

    constructor(item?: Interest){
        super();
        this.id = item && item.Id;
        this.name = item && item.Name
    }
 }


// WEBPACK FOOTER //
// ./src/app/models/inModels/Interest.ts